import { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as CloseStrokeSVG } from 'icons/close-stroke.svg';
import { format } from 'date-fns';

import { useOutsideClick } from 'helpers/clickOutside';

const PolygraphyModal = ({ event, onClose, onClickOutside }) => {
  const modalRef = useRef(null);
  const history = useHistory();

  useOutsideClick(modalRef, onClickOutside);

  return (
    <div
      className="fullscreen-modal-container"
      style={{ visibility: 'visible' }}
    >
      <div className="fullscreen-modal-background"></div>
      <div
        ref={modalRef}
        className="fullscreen-modal fullscreen-modal-action fullscreen-modal-wide"
      >
        <section className="modal-content">
          <header className="modal-header">
            <h1>{event.title}</h1>
          </header>
          <span onClick={onClose} className="pointer close">
            <CloseStrokeSVG />
          </span>

          <div className="modal-body">
            <p>
              {event.technician && (
                <>
                  <b>Technician:</b> {event.technician.firstName}{' '}
                  {event.technician.lastName}
                </>
              )}
              <br />
              <b>Delivery date: </b>
              {format(event.deliveryDate, 'dd.MM.yyyy, HH:mm')}
              <br />
              {event.notes && (
                <span>
                  <b>Notes:</b> {event.notes}
                </span>
              )}
            </p>
          </div>
          <span className="apps-grid-title">Patient</span>
          <div className="apps-grid">
            <div className="apps-grid-cell pointer">
              <article
                className="apps-card-app"
                onClick={() => history.push(`/customers/${event.customer.id}`)}
              >
                <div className="apps-card-left">
                  <div className="apps-card-meta">
                    <h3 className="apps-card-app-title">
                      {event.customer.firstName} {event.customer.lastName}
                    </h3>
                    <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                      {event.customer.email}
                    </p>
                    <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                      {event.customer.phone}
                    </p>
                    <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                      {event.customer.address}
                    </p>
                    <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                      {event.customer.address2}
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </div>
          <div className="modal-footer flex justify-end">
            <button
              data-cy="submit"
              className="btn-green"
              onClick={() => history.push(`/polygraphies/${event.id}`)}
            >
              <span>Go to polygraphy</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PolygraphyModal;
